module.exports = __webpack_public_path__ + "img/solution-software-system-pic-8.08161870.png";